module.exports = __webpack_public_path__ + "img/noAny.5ee5919c.svg";